import script from "./DepositoryPropertylistModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./DepositoryPropertylistModal.vue?vue&type=script&lang=ts&setup=true"

import "./DepositoryPropertylistModal.vue?vue&type=style&index=0&id=12710322&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12710322"]])

export default __exports__